<template>
  <va-card>
    <va-button @click="getSvcReports" style="white-space: nowrap;">export csv</va-button>
    <va-data-table ref="vuetable" :fields="fields" :data="items" :loading="loading" :totalPages="totalPages"
      @page-selected="readItems" api-mode>
      <template slot="order" slot-scope="props">
        <div>
          <router-link :to="{ name: 'orders-single', params: { id: props.rowData.order_id } }">{{  props.rowData.order  }}
          </router-link>

        </div>
      </template>
    </va-data-table>
  </va-card>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'reports-list',
  data() {
    return {
      loading: true,
      page: 1,
      limit: 10,
      ordering: '',
    }
  },
  computed: {
    ...mapState({
      items: state => state.Reports.items,
      totalPages: state => state.Reports.totalPages,
      hasMore: state => state.Reports.isHave,
    }),
    fields() {
      return [
        {
          name: 'to_whom',
          title: this.$t('reports.to_whom'),
          width: '60px',
        },
        {
          name: '__slot:order',
          title: this.$t('reports.order'),
          width: '60px',
        },
        {
          name: 'from_whom',
          title: this.$t('reports.from_whom'),
          width: '60px',
        },
        {
          name: 'user_role',
          title: this.$t('reports.user_role'),
          width: '60px',
        },
        {
          name: 'description',
          title: this.$t('reports.description'),
          width: '60px',
        },
      ]
    },
  },
  methods: {
    ...mapActions('Reports', ['getItems', 'getSvcReports']),
    async readItems(page = this.page) {
      this.loading = true
      this.page = page
      await this.getItems({ limit: this.limit, page: this.page, ordering: this.ordering })
      this.loading = false
    },
  },
  async created() {
    this.loading = true
    await this.getItems({ limit: this.limit, page: this.page, ordering: this.ordering })
    this.loading = false
  },
}
</script>
